import { tracked } from '@glimmer/tracking';

import FilterSortReportAtSelectPopup from 'webapp/models-custom/filter-sort/report-at-select-popup';

export default class FilterSortReportAtSelectPopupInList extends FilterSortReportAtSelectPopup {
	@tracked override viewId = 'table';
	override itemDomSelector = '.filter-sort-item';
}
